import { render, staticRenderFns } from "./d-form-recaptcha.vue?vue&type=template&id=965ab846&"
import script from "./d-form-recaptcha.vue?vue&type=script&lang=js&"
export * from "./d-form-recaptcha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports